<template>
  <div class="search-box">
      <h3>{{state.title}}</h3>
      <p>{{state.time}}</p>
    <div class="content" v-html="state.htmlText"></div>
  </div>
</template>
<script>
import { reactive, onMounted } from "vue";
import { getQueryString } from "@/utils/location";
import { getGameActivity } from "@/api/gameindex";

export default {
  name: "GameActivity",

  setup() {
    const state = reactive({
      htmlText: '',
      title:"",
      time:'',
    });

    onMounted(() => {
        var fromdata = {
          id: getQueryString("id"),
        };
        getGameActivity(fromdata).then((response) => {
          console.log(response.data);
          state.htmlText = response.data.post_content
          state.title = response.data.post_title
          state.time = response.data.post_date
        });
    });

    return {
      state,
    };
  },
};
</script>

<style scoped="scoped">

.search-box{
    text-align: center;
    padding: 30px;
}
.content {
  
}
</style>
